import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { FlexProps } from 'UIKit/Box/types'
import Image from 'UIKit/Image'
import Skeleton from 'UIKit/Skeleton'
import Text from 'UIKit/Text'
import { DepositFiatPaymentMethod, WithdrawFiatPaymentMethod } from 'config/types/payment'
import Column from 'layout/Components/Column'
import React, { PropsWithChildren } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { PaymentWrapOption } from './styles'

interface PaymentMethodCardProps<T> {
  method: T
  selectedMethod?: T
  onItemSelected?: (item: T) => void
  onSearchChanged?: (value) => void
}

export const Loader = () => {
  return (
    <Column style={{ gap: '20px' }}>
      <Column gap="8px">
        <PaymentWrapOption height="40px" width="100%">
          <Skeleton width="32px" height="32px" />
          <Skeleton width="100%" />
        </PaymentWrapOption>
        <PaymentWrapOption height="40px" width="100%">
          <Skeleton width="32px" height="32px" />
          <Skeleton width="100%" />
        </PaymentWrapOption>
      </Column>

      <Column gap="8px">
        <PaymentWrapOption height="40px" width="100%">
          <Skeleton width="32px" height="32px" />
          <Skeleton width="100%" />
        </PaymentWrapOption>
        <PaymentWrapOption height="40px" width="100%">
          <Skeleton width="32px" height="32px" />
          <Skeleton width="100%" />
        </PaymentWrapOption>
        <PaymentWrapOption height="40px" width="100%">
          <Skeleton width="32px" height="32px" />
          <Skeleton width="100%" />
        </PaymentWrapOption>
      </Column>

      <Column gap="8px">
        <PaymentWrapOption height="40px" width="100%">
          <Skeleton width="32px" height="32px" />
          <Skeleton width="100%" />
        </PaymentWrapOption>
      </Column>
    </Column>
  )
}

export const PaymentMethodCardContainer: React.FC<
  PropsWithChildren & {
    title: string
    Icon: any
  } & FlexProps
> = ({ title, Icon, children, ...props }) => {
  const { t } = useTranslation()

  return (
    <Column gap="8px" {...props}>
      <Flex alignItems="center">
        {<Icon size={24} />}
        <Text
          ml="8px"
          color="var(--pm-label-color)"
          fontSize="14px"
          fontWeight={500}
          letterSpacing={-0.24}
          lineHeight="normal"
        >
          {t(title)}
        </Text>
      </Flex>
      <Column gap="8px">{children}</Column>
    </Column>
  )
}

const PaymentMethodCard = <T extends DepositFiatPaymentMethod | WithdrawFiatPaymentMethod>({
  method,
  onItemSelected,
  selectedMethod,
  ...props
}: PaymentMethodCardProps<T> & FlexProps) => {
  return (
    <PaymentWrapOption
      onClick={() => {
        if (method.isActive) onItemSelected(method)
      }}
      selected={selectedMethod?.code === method.code}
      disabled={!method.isActive}
      {...props}
    >
      <Box minWidth="28px">
        <Image src={method.thumbnail} width={28} height={26} />
      </Box>
      <Column gap="4px">
        <Text textAlign="left" fontSize="14px" fontWeight={600} letterSpacing={-0.28} lineHeight="normal">
          {method.name}
        </Text>

        {!method.isActive && (
          <Text color="warning" fontSize="12px" fontWeight={500}>
            <Trans>This channel is under mantainance</Trans>
          </Text>
        )}
      </Column>
    </PaymentWrapOption>
  )
}

export default PaymentMethodCard
